export default __webpack_public_path__ + "static/media/header_mobile.1d7a6e09.png";